  import axios from 'axios';

  // Change this to your actual GoDaddy API URL
  const BASE_URL = 'https://www.gurukrupaeducation.com/api';

  export const saveAgreement = (formData) => {
    return axios.post(`${BASE_URL}/save_agreement.php`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  };

  export const getAgreements = (search = '', status = '') => {
    return axios.get(`${BASE_URL}/get_agreements.php`, {
      params: { search, status },
    });
  };

  export const getAgreement = (id) => {
    return axios.get(`${BASE_URL}/get_agreement.php`, { params: { id } });
  };

  export const approveAgreement = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    return axios.post(`${BASE_URL}/approve_agreement.php`, formData);
  };

  export const rejectAgreement = (id, reason = '') => {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('reason', reason);
    return axios.post(`${BASE_URL}/reject_agreement.php`, formData);
  };